<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            min="1"
            :error="errors.advancedGlucoseGlucose.length > 0"
            :error-messages="errors.advancedGlucoseGlucose"
            v-model="form.advancedGlucoseGlucose"
            :placeholder="$t('dashboard_new_evollu.measurement_types.advanced_glucose_glucose_short')+' (mg/dL)'"
            :label="$t('dashboard_new_evollu.measurement_types.advanced_glucose_glucose_short')+' (mg/dL)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.advancedGlucoseHemoglobinGlycated.length > 0"
          :error-messages="errors.advancedGlucoseHemoglobinGlycated"
          v-model="form.advancedGlucoseHemoglobinGlycated"
          :placeholder="$t('dashboard_new_evollu.measurement_types.advanced_glucose_hemoglobin_glycated_short')+ ' (%)'"
          :label="$t('dashboard_new_evollu.measurement_types.advanced_glucose_hemoglobin_glycated_short')+ ' (%)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="1"
          :error="errors.advancedGlucoseEstimatedAverage.length > 0"
          :error-messages="errors.advancedGlucoseEstimatedAverage"
          v-model="form.advancedGlucoseEstimatedAverage"
          :placeholder="$t('dashboard_new_evollu.measurement_types.advanced_glucose_estimated_average_short')+' (mg/dL)'"
          :label="$t('dashboard_new_evollu.measurement_types.advanced_glucose_estimated_average_short')+' (mg/dL)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>

  </div>
</template>

<script>
import moment from "moment";
const ADVANCED_GLUCOSE_GLUCOSE_TYPE_ID = 106
const ADVANCED_GLUCOSE_HEMOGLOBIN_GLYCATED_TYPE_ID = 107
const ADVANCED_GLUCOSE_ESTIMATED_AVERAGE_TYPE_ID = 117

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        advancedGlucoseGlucose: null,
        advancedGlucoseHemoglobinGlycated: null,
        advancedGlucoseEstimatedAverage: null,
      },
      errors: {
        advancedGlucoseGlucose: [],
        advancedGlucoseHemoglobinGlycated: [],
        advancedGlucoseEstimatedAverage: [],
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 25
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.advancedGlucoseGlucose !== null && this.form.advancedGlucoseGlucose !== '') ||
        (this.form.advancedGlucoseHemoglobinGlycated !== null && this.form.advancedGlucoseHemoglobinGlycated !== '') ||
        (this.form.advancedGlucoseEstimatedAverage !== null && this.form.advancedGlucoseEstimatedAverage !== '')

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.advancedGlucoseGlucose": function(value) {
        if(value !== '' && (value <= 0)) {
          this.errors.advancedGlucoseGlucose = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
        }
        else {
          this.errors.advancedGlucoseGlucose = []
        }

        if(this.measurement.measurements.find(meas => meas.typeId === ADVANCED_GLUCOSE_GLUCOSE_TYPE_ID)) {
          let elem = this.measurement.measurements.find(meas => meas.typeId === ADVANCED_GLUCOSE_GLUCOSE_TYPE_ID)
          elem.value = this.errors.advancedGlucoseGlucose.length === 0 ? value : null
        } else {
          this.measurement.measurements.push({
            value: this.errors.advancedGlucoseGlucose.length === 0 ? value : null,
            typeId: ADVANCED_GLUCOSE_GLUCOSE_TYPE_ID
          })
        }
      this.checkCanSubmit()
    },
    "form.advancedGlucoseHemoglobinGlycated": function(value) {
      if(value !== '' && (value < 0 || value > 100)) {
        this.errors.advancedGlucoseHemoglobinGlycated = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 0, max: 100})]
      }
      else {
        this.errors.advancedGlucoseHemoglobinGlycated = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === ADVANCED_GLUCOSE_HEMOGLOBIN_GLYCATED_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === ADVANCED_GLUCOSE_HEMOGLOBIN_GLYCATED_TYPE_ID)
        elem.value = this.errors.advancedGlucoseHemoglobinGlycated.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.advancedGlucoseHemoglobinGlycated.length === 0 ? value : null,
          typeId: ADVANCED_GLUCOSE_HEMOGLOBIN_GLYCATED_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.advancedGlucoseEstimatedAverage": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.advancedGlucoseEstimatedAverage = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.advancedGlucoseEstimatedAverage = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === ADVANCED_GLUCOSE_ESTIMATED_AVERAGE_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === ADVANCED_GLUCOSE_ESTIMATED_AVERAGE_TYPE_ID)
        elem.value = this.errors.advancedGlucoseEstimatedAverage.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.advancedGlucoseEstimatedAverage.length === 0 ? value : null,
          typeId: ADVANCED_GLUCOSE_ESTIMATED_AVERAGE_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
